import { Injectable, signal, WritableSignal } from '@angular/core';
import {User} from "@/app/model";

@Injectable({ providedIn: 'root' })
export class UserService {
  set user(user: User) {
    this._user.set(user);
  }
  get user(): WritableSignal<User | undefined> {
    return this._user;
  }
  private _user: WritableSignal<User | undefined> = signal(undefined);
}